module.exports = __webpack_public_path__ + "img/user.40d344ce.png";